import './src/styles/global.css';

import React from 'react';
import { TenantProvider } from './src/store/useTenant';
import { AppDataProvider } from './src/store/AppDataContext';
import { ToastHost } from './src/components/Toast';

// wrapRootElement: SOLO provider di contesto (auth + dati). Niente UI qui —
// Gatsby usa questo wrapper anche per estrarre gli head element, e la UI
// genererebbe il warning "<div> is not a valid head element".
export const wrapRootElement = ({ element }) => (
  <TenantProvider>
    <AppDataProvider>
      {element}
    </AppDataProvider>
  </TenantProvider>
);

// wrapPageElement: UI globale (ToastHost per le notifiche react-hot-toast).
export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <ToastHost />
  </>
);
